/**
 * Showroom opening hours — the single source for the contact page and the mobile sidebar.
 * `dayKeys` are universal text keys (first → last day of the range); `hours: null` = closed.
 */
export const OPENING_HOURS = [
  { dayKeys: ['text1302', 'text1306'], hours: '10:00 - 19:00' },
  { dayKeys: ['text1307'], hours: '10:00 - 14:00' },
  { dayKeys: ['text1308'], hours: null },
] as const;
